import {Component, OnInit} from '@angular/core';
import {ModalNavigationService} from '../../../../../services/gui/modal/modal-navigation.service';
import {Clipboard} from '@angular/cdk/clipboard';
import {ToasterService, ToastType} from '../../../../../services/toaster/toaster.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'licence-management-copy-serial-modal',
  templateUrl: './licence-management-copy-serial-modal.component.html',
  styleUrls: ['./licence-management-copy-serial-modal.component.scss'],
  standalone: false,
})
export class LicenceManagementCopySerialModalComponent implements OnInit {
  public serial: string;

  constructor(
    private clipboard: Clipboard,
    private translate: TranslateService,
    private toastService: ToasterService,
    private modalNavigation: ModalNavigationService
  ) {
    this.serial = this.modalNavigation.getCurrentNavigation().data.serial as string;
  }

  ngOnInit(): void {}

  public copyToClipboard(): void {
    this.clipboard.copy(this.serial);
    this.toastService.toast(ToastType.SUCCESS, this.translate.instant('lang.admin.licenceManagement.copiedSerial'));
    this.modalNavigation.result(true);
  }
}
